



































































































































































































































































import { Component, Vue } from 'vue-property-decorator';
import { Store } from 'vuex';
import { readUserProfile } from '@/store/main/getters';
import * as uploadImageListStore from '@/store/omr/vuex';
import { appName, canDebug } from '@/env';
import { dispatchUserLogOut } from '@/store/main/actions';
import UploadButton from './components/UploadButtonNew.vue';
import UploadPreview from './components/UploadPreview.vue';
import { ViewFileType } from './components/UploadPreview.vue';
import ImgView from './components/ImgView.vue';
import UploadEdit from './components/UploadEdit.vue';
import JumpDialog from './components/JumpDialog.vue';
import UploadStatement from './components/UploadStatement.vue';
import UploadPartDialog from './components/UploadPartDialog.vue';
import { UploadImageState } from '@/store/omr/state';
import { commitAddNotification, commitRemoveNotification } from '@/store/main/mutations';
import { assert } from 'pdfjs-dist/types/src/shared/util';
// import pdf from 'vue-pdf';

@Component({
  components: {
    UploadButton,
    UploadPreview,
    ImgView,
    UploadEdit,
    JumpDialog,
    UploadStatement,
    UploadPartDialog,
  },
})
export default class Upload extends Vue {
  public appName = appName;
  public canDebug = canDebug;
  public uploadStatementDialog: boolean = false;
  public showUploadStatementDialog: boolean = false;
  public msg: { content: string, showProgress: boolean } | null = null;
  // upload
  public scoreName: string = '';
  public defaultScoreName: string = '';
  public pdfFileList: FileList | null = null;
  public imgFileList: FileList | null = null;
  public moreCameraList: FileList | null = null;
  public inputFileList: FileList | null = null;
  public validInputFileType: ViewFileType | null = ViewFileType.pdf;
  public startIndex: number = 0;
  public numPages: number = 0;
  public canvasArr: HTMLCanvasElement[] = [];
  public imgArr: string[] = [];
  public showUploadPartialDialog: boolean = false;
  public showUploadTip: boolean = false;
  public showAddImageTip: boolean = false;
  public showAddImageTipTimeoutId: number = 0;
  public infoDialog: boolean = false;
  public uploadLoading: boolean = false;
  public overlay: boolean = false;
  public jumpDialog: boolean = false;
  public jumpRoute: string = '/omr/task/list';
  // img edit
  public rotateDegree: number = 0;
  public uploadEditDialog: boolean = false;
  public curImg: string  = ''; // base64
  public curImgName: string = 'none';
  public curImgArrIndex: number = 0;
  public transUUID: string = '';
  // score display
  public baseIframeMusicScoreSrc: string = 'https://www.aitanzou.com/analysis/v16_chatwebview/sheet.html?music_id=';
  public iframeMusicScoreHeight: string = '0px';
  // public musicId: string = '1162a4ac196935295da47eee812e2843';
  public musicId: string = '';
  // debug
  public canShowImg: boolean = false;
  public canShowScore: boolean = false;

  private pollDealEventRunId?: number;

  public reset() {
    this.transUUID = '';
    this.musicId = '';
    this.startIndex = 0;
    this.canShowScore = false;
    this.pollDealEventRunId = undefined;
  }

  public mounted() {
    // 本次网页全局加载后 第一次挂载后修改状态，也就是说浏览器上的刷新可以重置
    let autoShowStatement = uploadImageListStore.readAutoShowStatementDialog(this.$store);
    if (autoShowStatement) {
      this.uploadStatementDialog = true;
      autoShowStatement = false;
      uploadImageListStore.commitAutoShowStatementDialog(this.$store, autoShowStatement);
    }
    uploadImageListStore.commitSetScoreName(this.$store, '');
    uploadImageListStore.commitSetImgList(this.$store, []);
  }

  public show6sUploadTip() {
    this.showUploadTip = true;
    setTimeout(() => {
      this.showUploadTip = false;
    }, 6000);
  }

  public show3sAddImage() {
    if (this.showAddImageTipTimeoutId) {
      clearTimeout(this.showAddImageTipTimeoutId);
    }
    this.showAddImageTip = true;
    this.showAddImageTipTimeoutId = setTimeout(() => {
      this.showAddImageTip = false;
    }, 3000);
  }

// **** 选择上传 ****
  // **** 选择上传 - pdf ****
  public afterClickPdfUpload(pdfFileList?: FileList) {
    this.reset();
    const msg = { content: '加载PDF中', showProgress: true };
    this.msg = msg;
    commitAddNotification(this.$store, msg);
    if (pdfFileList === undefined || pdfFileList === null) {
      return;
    }
    this.defaultScoreName = pdfFileList[0].name.split('.')[0];
    this.pdfFileList = pdfFileList;
    this.inputFileList = pdfFileList;
    this.validInputFileType = ViewFileType.pdf;
    this.imgFileList = null;
    this.show6sUploadTip();
  }

  // **** 选择上传 - img ****
  public afterClickImgUpload(imgFileList?: FileList) {
    this.reset();
    const msg = { content: '加载图片中', showProgress: true };
    this.msg = msg;
    commitAddNotification(this.$store, msg);
    if (imgFileList === undefined || imgFileList === null) {
      return;
    }
    this.defaultScoreName = imgFileList[0].name.split('.')[0];
    this.imgFileList = imgFileList;
    this.inputFileList = imgFileList;
    this.validInputFileType = ViewFileType.img;
    this.pdfFileList = null;
    this.show3sAddImage();
    this.show6sUploadTip();
  }

  public afterClickMoreCameraUpload(imgFileList?: FileList) {
    const newImgFileList: File[] = [];
    if (this.inputFileList instanceof Array) {
      imgFileList && this.inputFileList.push(...imgFileList);
      return;
    }
    this.inputFileList && newImgFileList.push(...this.inputFileList);
    // this.imgFileList && newImgFileList.push(...this.imgFileList);
    imgFileList && newImgFileList.push(...imgFileList);
    // console.log(newImgFileList);
    this.inputFileList = newImgFileList as any; // TODO 考虑 全局修改FileList为 File[]
  }

// **** 工具栏 - 页码显示 ****
  public startIndexMinus() {
    if (this.startIndex > 0) {
      this.startIndex -= 1;
    }
  }

  public startIndexAdd() {
    if (this.startIndex < this.totalPageNum - 1) {
      this.startIndex += 1;
    }
  }

  get startPageNum() {
    return this.startIndex + 1;
  }
  /**
   * 等待子组件返回
   */
  get totalPageNum() {
    return this.numPages;
  }
// 等待子组件返回已渲染canvas
  public updateCanvasArr(canvasArr: HTMLCanvasElement[]) {
    if (this.msg) {
      commitRemoveNotification(this.$store, this.msg);
    }
    this.canvasArr = canvasArr;
    this.imgArr = canvasArr.map((canvas) => canvas.toDataURL('image/jpeg', 1.0));
    uploadImageListStore.commitSetImgList(this.$store, this.imgArr);
  }

  get uploadScoreName() {
    return this.scoreName || this.defaultScoreName || '未知曲谱';
  }

  public selectSingleImg(index: number) {
    this.curImgArrIndex = index;
    this.curImg = this.canvasArr[index].toDataURL('image/jpeg', 1.0);
    this.curImgName = `${this.uploadScoreName}-page-${index + 1}`;
  }

// **** 图片编辑 ****
  public imgCropDialog(index: number) {
    this.selectSingleImg(index);
    this.uploadEditDialog = true;
  }

  public afterCrop(img: string) {
    this.canShowImg = true;
    this.$set(this.imgArr, this.curImgArrIndex, img);
    uploadImageListStore.commitSetImgList(this.$store, this.imgArr);
  }
// 上传图片
  public actionUploadImageList(uploadScoreName: string, autoJump: boolean = true) {
    uploadImageListStore.commitSetScoreName(this.$store, uploadScoreName);
    const updatedProfile: UploadImageState = uploadImageListStore.readUploadImageState(this.$store);
    if (updatedProfile.img_list.length === 0) {
      this.infoDialog = true;
      return;
    }
    // 用户必须等待，不能操作，不能关闭
    this.overlay = true;
    this.uploadLoading = true;
    uploadImageListStore.dispatchCreateUploadImageList(this.$store, updatedProfile)
    .then((response) => {
      // 用户可以操作了
      this.overlay = false;
      this.uploadLoading = false;
      console.log(response.data);
      const transUUID = response.data;
      this.transUUID = transUUID;
      this.pollDealEvent(transUUID);
      // 弹框2s后跳转
      this.jumpDialog = autoJump;
    });
  }

  // 立即查询处理状态（只限这里使用）
  public pollDealEvent(transUUID: string) {
    const poll = (ms: number, first: boolean, firstRunId?: number) => {
      console.log(ms);
      const runId = setTimeout( () => {
        // console.log('runId', runId);
        const realFirstRunId = first ? runId : firstRunId;
        uploadImageListStore.dispatchGetDealEvent(this.$store, { transUUID, first })
        .then((response) => {
          if (ms > 64000) {
            return;
          }
          if (response.status === 202) {
            // tslint:disable-next-line: no-bitwise
            poll(ms << 1, false, realFirstRunId);
            return;
          }
          if (realFirstRunId === this.pollDealEventRunId) {
            console.log(response.data);
            this.musicId = response.data;
            this.canShowScore = this.musicId !== '';
          }
        }).catch((e: Error) => {
          console.log('转谱失败');
        });
      }, ms);
      return runId;
    };
    this.pollDealEventRunId = undefined;
    this.pollDealEventRunId = poll(2000, true, undefined);
  }

  get canNotDownload() {
    return this.musicId === '';
  }

// 下载曲谱
  public actionDownloadXmlScore() {
    const transUUID = this.transUUID;
    if (this.canNotDownload) {
      return;
    }
    uploadImageListStore.dispatchGetXmlScore(this.$store, { transUUID }).then((response) => {
      const filename = response.headers['content-disposition'];
      console.log(filename);
      const blob = new Blob([response.data]);
      const downloadElement = document.createElement('a');
      const href = window.URL.createObjectURL(blob);
      downloadElement.href = href;
      const xmlFilename = (this.scoreName + '.musicxml' || filename?.split('filename=')[1] || '未知曲谱.musicxml');
      downloadElement.download = decodeURIComponent(xmlFilename);
      document.body.appendChild(downloadElement);
      downloadElement.click();
      document.body.removeChild(downloadElement);
      window.URL.revokeObjectURL(href);
      // this.trans_uuid = '';
    });
  }

// score display
  get iframeMusicScoreSrc() {
    return this.baseIframeMusicScoreSrc + this.musicId;
  }

// user info and system info
  get greetedUser() {
    const userProfile = readUserProfile(this.$store);
    if (userProfile) {
      if (userProfile.nickname) {
        return userProfile.nickname;
      } else {
        return userProfile.email;
      }
    }
  }

  public async logout() {
    await dispatchUserLogOut(this.$store);
  }

// for debug
  public async alertClick() {
    // console.log(this.canvasArr);
    window.alert('文件为空');
  }

  public showImg() {
    this.canShowImg = !this.canShowImg;
  }

  public showScore() {
    this.canShowScore = !this.canShowScore;
    this.iframeMusicScoreHeight = '800px';
  }

  public getUploadImageList() {
    const imgList = uploadImageListStore.readUploadImageList(this.$store);
    console.log(imgList);
  }
}
